import React from "react";

import { Box, Hide } from "@catchoftheday/cg-components";
import {
  OnePassCancellationModalWithApollo,
  OnePassLinkingModalWithApollo,
  OnePassMigrationModalWithApollo,
  OnePassUpsellModalWithApollo,
} from "@catchoftheday/onepass";
import { ThemeProvider } from "@catchoftheday/theme";

import { CouponNotification } from "@header/components/CouponNotification";
import { FlashMessageBanner } from "@header/components/FlashMessageBanner";
import { MegaMenu } from "@header/components/MegaMenu";
import { OnePassNotificationWithApollo } from "@header/components/NotificationToast";
import { PrimaryHeader } from "@header/components/PrimaryHeader";
import theme from "@header/components/theme";
import { TopHeader } from "@header/components/TopHeader";

import { HeaderConfiguration } from "../../types";
import { HeaderToastContainer } from "../HeaderToast";

import { useHeaderMetaData } from "./metadata";

export type HeaderProps = {
  headerConfiguration?: HeaderConfiguration;
};

export const Header = ({ headerConfiguration }: HeaderProps) => {
  const { metaData, initialHeaderMetaData, isLoading } =
    useHeaderMetaData(headerConfiguration);
  return (
    <ThemeProvider
      theme={theme}
      enableGlobalFontConfig={false}
      enableGlobalBoxSizingConfig
      appName="header"
    >
      <Box position="relative" zIndex={2} maxWidth="100%">
        <Box id="top-header">
          {!isLoading && metaData?.couponNotificationEnabled && (
            <CouponNotification displayName={metaData?.displayName} />
          )}
          <Hide xs sm>
            <TopHeader
              isLoggedIn={metaData?.loggedIn}
              headerConfiguration={headerConfiguration}
            />
          </Hide>
        </Box>
        <PrimaryHeader
          id="primary-header"
          isLoading={isLoading}
          isLoggedIn={metaData?.loggedIn}
          isCCMember={metaData?.clubActive}
          isFlybuysLinked={metaData?.flybuysLinked}
          userName={metaData?.displayName}
          cartItemsAmount={metaData?.cartItemCount}
          wishItemsAmount={metaData?.wishlistItemCount}
          myAccountMessageCount={metaData?.messageCount}
          headerConfiguration={headerConfiguration}
        />
        {initialHeaderMetaData?.megaMenuEnabled &&
          initialHeaderMetaData?.navData && (
            <MegaMenu
              id="mega-menu"
              shops={initialHeaderMetaData.navData}
              essentialsMenu={initialHeaderMetaData.essentialsMenu}
              accountMenu={{
                ...initialHeaderMetaData.accountMenu,
                flybuysNotificationCount:
                  metaData?.flybuysNotificationCount ?? 0,
                unreadMarketplaceMessageCount:
                  metaData?.unreadMarketplaceMessageCount ?? 0,
              }}
              cartItemsCount={metaData?.cartItemCount}
              wishlistItemsCount={metaData?.wishlistItemCount}
              isLoggedIn={metaData?.loggedIn}
            />
          )}
        <FlashMessageBanner />
        <HeaderToastContainer />
        <OnePassLinkingModalWithApollo />
        <OnePassMigrationModalWithApollo />
        <OnePassCancellationModalWithApollo />
        <OnePassUpsellModalWithApollo />
        <OnePassNotificationWithApollo />
      </Box>
    </ThemeProvider>
  );
};
